import type { SelectOption } from '@/shared/ui';
import { SettlementStatisticsRevenuePatchRequestRevenueSourceTypeValue } from '../api/generated/model';

/**
 * 財源区分の enum（短縮エイリアス）
 */
export const RevenueSourceTypeValue = SettlementStatisticsRevenuePatchRequestRevenueSourceTypeValue;
export type RevenueSourceTypeValue = SettlementStatisticsRevenuePatchRequestRevenueSourceTypeValue;

/**
 * 財源区分の z.enum() 用バリュー配列
 */
export const revenueSourceTypeValues = Object.values(RevenueSourceTypeValue) as [
  RevenueSourceTypeValue,
  ...RevenueSourceTypeValue[],
];

/**
 * 財源区分の SelectField 用オプション
 */
export const revenueSourceTypeSelectOptions: SelectOption[] = Object.values(
  RevenueSourceTypeValue,
).map((value) => ({
  label: value,
  value,
}));
